<template>
    <div>
        <div class="infoBox mb20">

            <div class="item flex">
                <label class="itemTitle" for="">
                    {{ ('참여자명') }} <span class="redPoint">*</span>  <button class="tooltip" @click="tooltip('track_title')"></button>
                </label>
                <div style="display: flex; align-items: center;">
                   <input type="text" name="" id="" v-model="dataTemplate.name">
                </div>
            </div>

            <div class="item flex" style="margin-top:16px;">
                <label class="itemTitle" for="">
                    {{ ('참여자명(번역)') }}
                </label>
                <div style="flex:1;">
                    <multiLang :langList="dataTemplate.name_multilang" title="참여자명" @changeUpdate="updateNameMultilang"/>
                </div>
            </div>

            <div class="item flex" style="margin-top:16px;">
                <label class="itemTitle" for="">
                    {{ ('참여자명(스토어별)') }}
                </label>
                <div style="flex:1;">
                    <djLang :langList="dataTemplate.name_export" title="참여자명" @changeUpdate="updateNameExport"/>
                </div>
            </div>

            <div class="item flex" style="margin-top:16px;">
                <label class="itemTitle" for="">
                    {{ ('External ID') }}
                </label>
                <div style="flex:1;">
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/4">
                            <v-select class="w-full" placeholder="타입"
                                v-model="newExternalType"
                                :options="externalOptions"
                                :clearable="false"/>
                        </div>
                        <div class="vx-col sm:w-1/2">
                            <vs-input class="w-full" v-model="newExternalValue" placeholder="ID"/>
                        </div>
                        <div class="vx-col" style="align-self:center;">
                            <vs-button @click="addNewExternal" type="filled">추가</vs-button>
                        </div>
                    </div>
                    <vs-table :data="dataTemplate.id_external">
                        <template slot="thead">
                            <vs-th>타입</vs-th>
                            <vs-th>ID</vs-th>
                            <vs-th></vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>{{ tr.type }}</vs-td>
                                <vs-td>{{ tr.value }}</vs-td>
                                <vs-td>
                                    <vs-button color="danger" style="padding:5px 10px;" @click="removeNewExternal(indextr)">x</vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>

        </div>
         <div class="btnBox">
            <button class="btn big" @click="closeModal('track')">{{ ('취소') }}</button>
            <button class="btn big blue" @click="artistRegister">{{ ('저장') }}</button>
        </div>


    </div>
</template>
<script>
export default {
    name: 'trackModals',
    props: {
        default : 'artist'
    },
    data(){
        return({


            dataTemplate : {
                "name": null,
                "name_multilang": {},
                "name_export": {},
                "id_external": [],
            },
            externalOptions: ['spotify', 'apple', 'melon'],
            newExternalType: 'spotify',
            newExternalValue: null,

        })
    },
    computed: {
        yearList(){
            const currentYear = new Date().getFullYear();
            let years = [];
            for(let i=currentYear; i>=1950; i--){
                years.push({ value: ''+i, label: ''+i })
            }
            return years
        }
    },
    created(){
        //this.dataTemplate = this.modelValue
    },
    methods: {
        updateNameMultilang(data){
            this.dataTemplate.name_multilang = data
        },
        updateNameExport(data){
            this.dataTemplate.name_export = data
        },
        addNewExternal(){
            if(!this.newExternalType){
                this.alert({msg: '타입을 선택해주세요.'})
                return false
            }
            if(!this.newExternalValue){
                this.alert({msg: 'ID를 입력해주세요.'})
                return false
            }
            for (const item of this.dataTemplate.id_external) {
                if (item.type === this.newExternalType) {
                    this.alert({msg: '이미 등록된 타입입니다.'})
                    return false
                }
            }
            this.dataTemplate.id_external.push({
                type: this.newExternalType,
                value: this.newExternalValue,
            })
            this.newExternalValue = null
        },
        removeNewExternal(index){
            this.dataTemplate.id_external.splice(index, 1)
        },
        artistRegister() {
            if(!this.dataTemplate.name){
                this.alert({msg:
                    '참여자 이름을 입력해주세요.'
                })
                return false
            }

            for (const key in this.dataTemplate.name_multilang) {
                if (!this.dataTemplate.name_multilang[key]) {
                    delete this.dataTemplate.name_multilang[key]
                }
            }
            for (const storeKey in this.dataTemplate.name_export) {
                const inner = this.dataTemplate.name_export[storeKey]
                if (inner && typeof inner === 'object') {
                    for (const langKey in inner) {
                        if (!inner[langKey]) delete inner[langKey]
                    }
                    if (Object.keys(inner).length === 0) {
                        delete this.dataTemplate.name_export[storeKey]
                    }
                }
            }

            let params = { ...this.dataTemplate }
            this.$store.dispatch('POST_CONTRIBUTOR_V2', params)
                .then(result => {
                    this.emitter.emit('contributorAdd');

                    this.closeModal('contributorRegistration')

                }).catch(error =>{
                    this.loadingHide()
                    //this.closePanel(true)
                    console.log(error)
                    if(error.response && error.response.data.code== 300 ){
                        this.alert({msg: '이미 등록된 참여자 이름이 있습니다.'})
                        return false
                    }
                    this.alert({msg: error})

                })
            },
    },


}
</script>
